import React from 'react';

const Contact = () => {
    console.log('Hit Contact');
    return (
        <div>
            <h3>
                Contact Us
        </h3>
        </div>
    )
}

export default Contact;